<div class="container-fluid admin-form-page">
  <div class="row section1 align-items-center">
    <div class="col-12 col-md-7 col-lg-7 col-xl-7">
      <div class="home-details">
        <h5 class="home-title">Create Rating Category</h5>
        <p class="home-subtitle">Enter all Category details</p>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-5 col-xl-5">
      <div class="dashboard-btn dashboard-manage admin-page-actions">
        <button (click)="goBack()" type="button" class="btn btn-primary btn-dashboard">Back</button>
        @if (!isCategoryCreated) {
          <button
            type="button"
            (click)="submitForm()"
            [disabled]="loading"
            class="btn btn-primary btn-dashboard">
            {{loading ? 'Saving...' : 'Save Category'}}
          </button>
        }
      </div>
    </div>
  </div>

  <div class="section1">
    @if (isCategoryCreated) {
      <div class="alert alert-success alert-dismissible fade show"
        style="margin:10px 0;"
        role="alert">
        {{message}}
      </div>
    }

    <div class="applicants-details details1 admin-form-card">
      <div class="admin-form create-rating-page">
        @if (!isCategoryCreated) {
          <form class="admin-form" ngNativeValidate (ngSubmit)="createRatingCategory()">
            <section class="form-section">
              <h5 class="section-title">Category Details</h5>
              <div class="row align-items-end">
                <div class="col-12 col-lg-3">
                  <div class="user-form">
                    <div class="form-group">
                      <label for="type">Category Type*</label>
                      <select id="type" class="form-control" [(ngModel)]="rateCategory.type" name="type">
                        <option [ngValue]="1">Entity</option>
                        <option [ngValue]="2">NFT</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-3">
                  <div class="user-form">
                    <div class="form-group">
                      <label for="cat-icon">Category Icon*</label>
                      <input type="file"
                        class="form-control"
                        id="cat-icon"
                        name="cat-icon"
                        accept="image/*"
                        (change)="uploadImage($event)"
                        required>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-2">
                  <div class="icon-preview-box">
                    @if (uploading) {
                      <div class="spinner-border spinner-border-sm" role="status"></div>
                    }
                    @if (!uploading && !!rateCategory.icon) {
                      <img [src]="rateCategory.icon" alt="Category icon">
                    }
                  </div>
                </div>
                <div class="col-12 col-lg-2">
                  <div class="user-form">
                    <div class="form-group">
                      <label for="category-name">Rating Category Name*</label>
                      <input type="text"
                        class="form-control"
                        id="category-name"
                        [(ngModel)]="rateCategory.name"
                        name="category-name"
                        placeholder="Rating category Name"
                        required>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-2">
                  <div class="user-form">
                    <div class="form-group">
                      <label for="popular">Is Popular*</label>
                      <select id="popular" class="form-control" [(ngModel)]="rateCategory.popular_index" name="popular_index">
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section class="form-section">
              <h5 class="section-title">Rating Rules</h5>
              <div class="row">
                <div class="col-12 col-lg-6">
                  <label>Rating Positive/Negative Criteria Type*</label>
                  <div class="criteria-options">
                    <label class="criteria-option" for="SecularismType">
                      <input type="radio"
                        id="SecularismType"
                        [(ngModel)]="rateCategory.RatingPositiveNegativeCriteriaType"
                        value="secularism_index"
                        name="PositiveNegativeCriteriaType">
                      <span>Parameter 1 should be greater than 2 and 3</span>
                    </label>
                    <label class="criteria-option" for="BhaktType">
                      <input type="radio"
                        id="BhaktType"
                        [(ngModel)]="rateCategory.RatingPositiveNegativeCriteriaType"
                        value="bhakt_index"
                        name="PositiveNegativeCriteriaType">
                      <span>All parameters should be greater than specific percentage</span>
                    </label>
                  </div>
                </div>
                @if (rateCategory.RatingPositiveNegativeCriteriaType === 'bhakt_index') {
                  <div class="col-12 col-lg-3">
                    <div class="user-form">
                      <div class="form-group">
                        <label for="positive-percent">Minimum percentage for positive rating*</label>
                        <input type="tel"
                          class="form-control"
                          id="positive-percent"
                          name="RatingPositiveNegativePercent"
                          [(ngModel)]="rateCategory.RatingPositiveNegativePercent"
                          required
                          maxlength="3"
                          placeholder="Enter percentage"
                          oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1')">
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </section>
              <section class="form-section">
                <h5 class="section-title">Category Mapping</h5>
                <label class="mb-2 d-block">Select categories (At least one)*</label>
                <div class="chip-list">
                  @for (c of categories; track c) {
                    <label class="category-chip" [for]="'category'+c.id">
                      <span>{{c.categoryName}}</span>
                      <input type="checkbox"
                        [id]="'category'+c.id"
                        [value]="c.id"
                        (change)="catChange($event, c.id)">
                    </label>
                  }
                </div>
              </section>
              <section class="form-section">
                <h5 class="section-title">Description</h5>
                <angular-editor placeholder="Enter Description"
                  name="description"
                  [config]="editorConfig"
                  id="description"
                  [(ngModel)]="rateCategory.description">
                </angular-editor>
              </section>
              <button id="form_submit" type="submit" class="d-none">Save Category</button>
            </form>
          }

          @if (isCategoryCreated) {
            <div class="form-section">
              <div class="section-title-row">
                <h5 class="section-title mb-0">Rating Parameters</h5>
                <button type="submit" class="btn btn-primary btn-dashboard" form="rating-params-form">
                  Add Parameters
                </button>
              </div>
              <form id="rating-params-form" class="admin-form" ngNativeValidate (ngSubmit)="createRatingParameters()">
                @for (item of ratingParameters; track item; let ind = $index) {
                  <div class="param-row">
                    <div class="row align-items-end">
                      <div class="col-12 col-lg-4">
                        <div class="user-form">
                          <div class="form-group">
                            <label for="param-name-{{ind}}">Parameter Name*</label>
                            <input (input)="onParamChange($event.target.value, ind)"
                              placeholder="Enter Parameter Name"
                              id="param-name-{{ind}}"
                              type="text"
                              class="form-control"
                              name="name-{{ind}}"
                              required>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-4">
                        <div class="user-form">
                          <div class="form-group">
                            <label for="param-icon-{{ind}}">Rating Icon*</label>
                            <input type="file"
                              class="form-control"
                              id="param-icon-{{ind}}"
                              name="icon-{{ind}}"
                              accept="image/*"
                              required
                              (change)="pickIcon($event, ind)">
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-1">
                        <div class="icon-preview-box small">
                          @if (ratingParameters[ind].icon) {
                            <img [src]="ratingParameters[ind].icon" alt="Parameter icon">
                          }
                        </div>
                      </div>
                      <div class="col-12 col-lg-3">
                        <div class="user-form">
                          <div class="form-group">
                            <label for="param-description-{{ind}}">Description*</label>
                            <textarea maxlength="80"
                              class="form-control"
                              id="param-description-{{ind}}"
                              name="description-{{ind}}"
                              [(ngModel)]="ratingParameters[ind].description"
                            required></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                <button type="submit" class="d-none">Add Parameters</button>
              </form>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
